import { IInstitutionRegistry, IInstitutionRepository } from "../../../domain/institution";
import { InstitutionRepository } from ".";

export class InstitutionRegistry implements IInstitutionRegistry {
  constructor(private _getToken: () => string) {
  }
  
  getInstitutionRepository(): IInstitutionRepository {
    return new InstitutionRepository(this._getToken);
  }
}
